import type { ProductIdFilterDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Filter/ProductIdFilterDataAccessObject'
import { ProductIdFilter } from './ProductIdFilter'

export class ProductIdFilterEncoder {
  static encode(instance: ProductIdFilter): ProductIdFilterDataAccessObject {
    return {
      name: instance.name.value,
      entries: instance.entries.value,
    }
  }

  static decode(properties: ProductIdFilterDataAccessObject): ProductIdFilter {
    return new ProductIdFilter(properties.name, properties.entries)
  }
}
